import React, { useState } from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderDollar, renderFieldDisabled, renderCurrency, renderDollarDisabled, renderCurrencyDisabled, CustomCurrencyDisabled, CustomDollarDisabled } from '../../../../Utils/renderField/renderField';
import { renderField } from "../../../../Utils/renderField/renderField"
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { months } from '../../../../Utils/months';
import { formatCurrency, updateSummaryTotals, useSummaryTotalsLocal, updateSummaryTotalsOnSave } from './CashFlowComponents';

// Componente para mostrar valores calculados localmente (similar a ResultadosTable)
const LocalCurrencyDisplay = ({ value, currency, isSalida }) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '';
    }
    
    const numericValue = parseFloat(value) || 0;
    
    // Usar la misma función formatCurrency pero con valores locales
    return formatCurrency(numericValue, currency, numericValue < 0 || isSalida);
};

const TableRow = ({ system, index, fields, change, currency, localTotals }) => {
    const _months = months
    const is_manual = fields.get(index).is_manual;
    const isTitulo = fields.get(index).isTitulo;
    const currentRow = fields.get(index);
    const isSalida = currentRow.type_of_flow === "salidas" || (currentRow.name && currentRow.name.includes("PAGOS")) || (currentRow.name && currentRow.name.includes("SALIDAS"));
    const isFinal = fields.get(index).isFinal
    const isOpeningBalance = fields.get(index).isOpeningBalance

    // Obtener valores calculados localmente para las filas del resumen
    const getLocalValue = (month) => {
        if (!localTotals) return 0;
        
        // Mapear indices del resumen con los totales locales
        switch (index) {
            case 1: // ENTRADAS
                return localTotals.entradas[month] || 0;
            case 2: // SALIDAS  
                return localTotals.salidas[month] || 0;
            case 3: // FLUJO NETO
                return localTotals.flujoNeto[month] || 0;
            case 4: // SALDO FINAL
                return localTotals.saldoFinal[month] || 0;
            default:
                return parseFloat(currentRow[month]) || 0;
        }
    };

    React.useEffect(() => {
        change(`${system}.is_dollar`, currency === 'USD');
    }, [currency, system, change]);

    const calculateTotalForRow = () => {
        // Para filas del resumen (índices 1-4), usar totales locales
        if (localTotals && index >= 1 && index <= 4) {
            switch (index) {
                case 1: return localTotals.entradas.total || 0;
                case 2: return localTotals.salidas.total || 0;
                case 3: return localTotals.flujoNeto.total || 0;
                case 4: return localTotals.saldoFinal.total || 0;
                default: break;
            }
        }

        // Para otras filas, calcular normalmente
        const systemData = fields.get(index);
        if (!systemData) return 0;

        let totalForRow = _months.reduce((accumulatedTotal, month) => {
            const value = parseFloat(systemData[month]) || 0;
            accumulatedTotal += value;
            return accumulatedTotal;
        }, 0);
        return totalForRow;
    };
    
    const textStyle = isSalida ? { color: '#dc3545', fontWeight: '500' } : {};
    const cellStyle = { ...textStyle, width: "8%" };
    const finalStyle = isFinal ? { backgroundColor: "#F0FFC7", ...cellStyle } : cellStyle;
    
    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td className='first-column table-form-fixed-cell-left-0' style={!isFinal ? {} : { backgroundColor: "#F0FFC7", minWidth: "200px" }} >
                    <Field
                        name={`${system}.name`}
                        type="text"
                        isTextarea={!isTitulo}
                        applyStyles={!isTitulo}
                        style={textStyle}
                        component={renderFieldDisabled}
                        className="form-control"
                        placeholder='Resumen'
                    />
                </td>
                <td className='table-form-fixed-cell-left-1' style={finalStyle}>
                    <LocalCurrencyDisplay value={calculateTotalForRow()} currency={currency} isSalida={isSalida} />
                </td>
                {!isOpeningBalance ?
                    months.map((month) => {
                        // Para filas calculadas (resumen), mostrar valores locales
                        const shouldShowCalculatedValue = localTotals && index >= 1 && index <= 4;
                        
                        if (shouldShowCalculatedValue) {
                            return (
                                <td key={month} style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                                    <div style={{ 
                                        padding: '0.375rem 0.75rem', 
                                        textAlign: 'right',
                                        color: isSalida ? '#dc3545' : 'inherit',
                                        fontWeight: isSalida ? '500' : 'normal'
                                    }}>
                                        <LocalCurrencyDisplay 
                                            value={getLocalValue(month)} 
                                            currency={currency} 
                                            isSalida={isSalida}
                                        />
                                    </div>
                                </td>
                            );
                        }
                        
                        // Para campos editables, mantener el Field normal
                        return (
                            <td key={month} style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                                <Field
                                    name={`${system}.${month}`}
                                    component={is_manual ? (currency === 'USD' ? renderDollar : renderCurrency) : (currency === 'USD' ? CustomDollarDisabled : CustomCurrencyDisabled)}
                                    placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                                    disabled={!is_manual}
                                    style={isSalida ? {
                                        color: '#dc3545',
                                        fontWeight: '500',
                                        borderColor: '#dc3545',
                                        backgroundColor: '#fff5f5'
                                    } : {}}
                                    isSalida={isSalida}
                                />
                            </td>
                        );
                    })
                    :
                    <React.Fragment>
                        <td style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                            <Field
                                name={`${system}.enero`}
                                component={currency === 'USD' ? renderDollar : renderCurrency}
                                placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                                disabled={false}
                                style={isSalida ? {
                                    color: '#dc3545',
                                    fontWeight: '500',
                                    borderColor: '#dc3545',
                                    backgroundColor: '#fff5f5'
                                } : {}}
                            />
                        </td>
                        {/* Celdas vacías para el resto de los meses */}
                        {months.slice(1).map((month) => (
                            <td key={month} style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                                &nbsp;
                            </td>
                        ))}
                    </React.Fragment>
                }
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, allValues, change, currency }) => {
    // Calcular totales localmente (similar a ResultadosTable)
    const localTotals = useSummaryTotalsLocal(allValues);

    const columnas = Array.from({ length: 12 }, (_, index) => (
        <th key={index} style={{ width: "6.9%" }}>{index + 1}</th>
    ));

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className='table-responsive'>
                <table className="table table-striped mb-0">
                    <thead className="thead-not-cursor">
                        <tr>
                            <th className='first-column table-form-fixed-cell-left-0 titulo-left-padded'>MES</th>
                                <th className='table-form-fixed-cell-left-1 text-right-padded-sm'>TOTAL</th>
                                {columnas}
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "#F0FFC7" }}>
                            {fields.map((system, index) => (
                                <TableRow 
                                    key={index} 
                                    system={system} 
                                    index={index} 
                                    fields={fields} 
                                    change={change} 
                                    currency={currency} 
                                    localTotals={localTotals}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
        </div>
    );
}

const ResumeFlow = ({ allValues, change, currency }) => {

    return (
        <div>
            <FieldArray
                name={`summary`}
                component={GenericTable}
                allValues={allValues}
                change={change}
                currency={currency}
            />
        </div>
    );
}

const formName = 'CashFlowForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const allValues = selector(state, 'financial', 'operation', 'investments', 'summary') || {};
    return { 
        allValues: {
            financial: allValues.financial || [],
            operation: allValues.operation || [],
            investments: allValues.investments || {},
            summary: allValues.summary || []
        }
    };
};

export default connect(mapStateToProps)(ResumeFlow);
